import React from 'react'
import { links } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import Link from 'components/ui/Link/Link'

import messages from './messages'
import s from './LandingSubNav.scss'


const nav = [
  { title: messages.women, to: links.home },
  { title: messages.men, toOLD: links.homeMen },
  { title: messages.howItWorks, to: links.howItWorks },
]

const LandingSubNav = () => (
  <div className={s.nav}>
    {
      nav.map(({ title, ...rest }, index) => (
        <Link key={index} className={s.item} activeClassName={s.active} customColor {...rest}>
          <FormattedMessage {...title} />
        </Link>
      ))
    }
  </div>
)


export default LandingSubNav
